"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = require("classnames");
var smartimagesrc_1 = require("@ezbuy/smartimagesrc");
var mobx_1 = require("mobx");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var common_1 = require("services/page/common");
var prm_1 = require("../../../../utils/prm");
var link_1 = require("../../../utils/link");
var mutil_Language_1 = require("../../../utils/mutil-Language");
var Styles = require("./index.scss");
var store_1 = require("./store");
var Image_1 = require("../../../components/Image");
var WithPrm_1 = require("components/WithPrm");
var Cube = (function (_super) {
    __extends(Cube, _super);
    function Cube(props) {
        var _this = _super.call(this, props) || this;
        _this.windowScrollTimeoutId = 0;
        _this.countDown = function () {
            setInterval(function () {
                _this.setState(function (_a) {
                    var countdown = _a.countdown;
                    return ({
                        countdown: countdown - 1000
                    });
                });
            }, 1000);
        };
        _this.onTouchStart = function (e) {
            if (!_this.isDragging()) {
                var touch = e.touches[0];
                var dragPoints = {
                    startPoint: {
                        x: touch.clientX,
                        y: touch.clientY
                    }
                };
                _this.setState({
                    dragPoints: dragPoints,
                    animationPlayState: "paused"
                });
                clearInterval(_this.windowScrollTimeoutId);
            }
        };
        _this.onTouchMove = function (e) {
            if (_this.isDragging()) {
                var touch = e.touches[0];
                var endPoint = {
                    x: touch.clientX,
                    y: touch.clientY
                };
                var startPoint = _this.state.dragPoints.startPoint;
                if (Math.abs(endPoint.y - startPoint.y) > Math.abs(endPoint.x - startPoint.x)) {
                    _this.setState({ dragPoints: null });
                    _this.onScroll();
                }
                else {
                    var dragPoints = Object.assign({}, _this.state.dragPoints, {
                        endPoint: endPoint
                    });
                    _this.setState({ dragPoints: dragPoints, animationPlayState: "paused" });
                    clearInterval(_this.windowScrollTimeoutId);
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        };
        _this.onTouchEnd = function (e) {
            var _a = _this.state, dragPoints = _a.dragPoints, cIndex = _a.cIndex;
            if (_this.isDragging()) {
                var updateState = {
                    dragPoints: null
                };
                if (typeof dragPoints.endPoint !== "undefined") {
                    _this.onScroll();
                    var distance = dragPoints.startPoint.x - dragPoints.endPoint.x;
                    var distanceAbs = Math.abs(distance);
                    if (distanceAbs > 40) {
                        if (distance < 0) {
                            updateState.cIndex = cIndex - 1;
                        }
                        else {
                            updateState.cIndex = cIndex + 1;
                        }
                    }
                    if (updateState.cIndex < 0) {
                        updateState.cIndex = 0;
                    }
                    if (updateState.cIndex > _this.getNodeCount() - 1) {
                        updateState.cIndex = _this.getNodeCount() - 1;
                    }
                    updateState.animationPlayState = "running";
                }
                _this.setState(updateState);
            }
            if (dragPoints === null || typeof dragPoints.endPoint !== "undefined") {
                e.stopPropagation();
                e.preventDefault();
            }
        };
        _this.onTransitionEnd = function () {
            var Cube = _this.store.Cube;
            var cIndex = _this.state.cIndex;
            if (cIndex + 1 > Cube.length / 2) {
                _this.setState({ cIndex: 0, animationDuration: 0 });
                setTimeout(function () {
                    _this.setState({
                        animationDuration: 1000
                    });
                }, 500);
            }
        };
        _this.onScroll = function () {
            clearInterval(_this.windowScrollTimeoutId);
            _this.windowScrollTimeoutId = setInterval(function () {
                if (_this.state.countdown > 0) {
                    _this.setState(function (_a) {
                        var countdown = _a.countdown;
                        return ({
                            countdown: countdown - 100
                        });
                    });
                }
                else {
                    if (!_this.state.countdown) {
                        _this.setState({ cIndex: _this.state.cIndex + 1 });
                    }
                    _this.setState({ countdown: 16000 });
                }
            }, 100);
        };
        _this.state = {
            cIndex: 0,
            animationPlayState: "running",
            dragPoints: null,
            wrapperOffsetLeft: 0,
            countdown: 15000,
            animationDuration: 1000
        };
        _this.store = new store_1.CubeStore(props.moduleDetail);
        return _this;
    }
    Cube.prototype.componentDidMount = function () {
        this.onScroll();
    };
    Cube.prototype.componentWillUnmount = function () {
        clearInterval(this.windowScrollTimeoutId);
    };
    Cube.prototype.genLinkByUrl = function (link, order) {
        if (link) {
            var tprm = this.props.tprm;
            var url = prm_1.genPrmLink(link, __assign(__assign({}, tprm), { position: order }));
            link_1.clickJump(url);
        }
        return "javascript:void";
    };
    Cube.prototype.getStyle = function () {
        var _a = this.state, cIndex = _a.cIndex, dragPoints = _a.dragPoints, animationDuration = _a.animationDuration, animationPlayState = _a.animationPlayState;
        var style = {};
        var wrapperOffsetLeft = -1 * cIndex * 91;
        style.transform = "translate3d(" + wrapperOffsetLeft / 16 + "rem ,0 ,0)";
        style.transitionDuration = animationDuration + "ms";
        if (this.isDragging() && animationPlayState === "paused") {
            var endPoint = dragPoints.endPoint, startPoint = dragPoints.startPoint;
            if (typeof endPoint !== "undefined") {
                var distance = 0;
                if (startPoint.x - endPoint.x >= 0) {
                    distance = startPoint.x - endPoint.x > 86 ? 86 : startPoint.x - endPoint.x;
                }
                else {
                    distance = startPoint.x - endPoint.x < -86 ? -86 : startPoint.x - endPoint.x;
                }
                if (cIndex > 0 || (cIndex === 0 && distance > 0)) {
                    style.transform = "translate3d(" + (wrapperOffsetLeft - distance) / 16 + "rem,0,0)";
                }
            }
        }
        style.WebkitTransform = style.transform;
        style.transitionTimingFunction = "ease-out";
        return style;
    };
    Cube.prototype.isDragging = function () {
        return this.state.dragPoints !== null;
    };
    Cube.prototype.render = function () {
        var _this = this;
        var _a = this.props, index = _a.index, addModuleMap = _a.addModuleMap, commonProps = _a.commonProps;
        var animationPlayState = this.state.animationPlayState;
        var _b = this.store, Cube = _b.Cube, interaction = _b.interaction;
        var concatCube = Cube.length > 8 ? Cube.slice(0, 10) : Cube.concat(Cube.slice(0, 2));
        if (interaction === common_1.ModuleInteraction.Zoom) {
            return (React.createElement("div", { ref: function (node) {
                    if (node) {
                        addModuleMap(index, node, "#" + commonProps.id);
                    }
                }, id: this.props.id },
                React.createElement("div", { className: classnames_1.default(Styles.Wrap), onTouchStart: this.onTouchStart, onTouchMove: this.onTouchMove, onTouchEnd: this.onTouchEnd, onTouchCancel: this.onTouchEnd }, mobx_1.toJS(Cube)
                    .concat(concatCube)
                    .map(function (item, index) {
                    var cube = item && item.items[0];
                    return (React.createElement("div", { className: classnames_1.default(Styles.Cube), key: "Cube_Zoom_" + index, style: _this.getStyle(), onTransitionEnd: _this.onTransitionEnd },
                        React.createElement("a", { href: _this.genLinkByUrl(mutil_Language_1.multilingualLinkDisplay(cube) || undefined, index + 1), target: "_blank" },
                            React.createElement(Image_1.default, { src: smartimagesrc_1.makeImageUrls(mutil_Language_1.multilingualImgDisplay(cube), {
                                    online: true,
                                    qnParams: { w: 190 },
                                    aliSize: 2
                                })[0], style: { animationPlayState: animationPlayState }, params: "imageView2/2/w/190", alisize: 2 }))));
                }))));
        }
        if (interaction === common_1.ModuleInteraction.ZoomSliding) {
            return (React.createElement("div", { ref: function (node) {
                    if (node) {
                        addModuleMap(index, node, "#" + commonProps.id);
                    }
                }, id: this.props.id },
                React.createElement("div", { className: classnames_1.default(Styles.ZoomSlidingWrap) }, mobx_1.toJS(Cube).map(function (item, index) {
                    var cube = item && item.items[0];
                    return (React.createElement("div", { className: classnames_1.default(Styles.Cube), key: "Cube_ZoomSliding_" + index },
                        React.createElement("a", { onClick: function () { return _this.genLinkByUrl(cube.link || undefined, index + 1); }, target: "_blank" },
                            React.createElement(Image_1.default, { src: smartimagesrc_1.makeImageUrls(cube.img, {
                                    online: true,
                                    qnParams: { w: 190 },
                                    aliSize: 2
                                })[0], params: "imageView2/2/w/190", alisize: 2 }))));
                }))));
        }
        return null;
    };
    Cube.prototype.getNodeCount = function () {
        return (this.store.Cube.length + 8) / 2;
    };
    Cube = __decorate([
        mobx_react_1.observer
    ], Cube);
    return Cube;
}(React.Component));
exports.default = WithPrm_1.default(Cube);
